import React, { useContext, useRef, useState } from "react";
import { TextareaAutosize } from "@mui/base/TextareaAutosize";
import AlertContext from "../../context/AlertContext";
import CommentsHooks from "../../Hooks/CommentsHooks";
import constants from "../../constants";
import { nanoid } from "nanoid";
import { Typography } from "@mui/material";
import Button from "../Button";
import { getDataFromStorage } from "../../util";
import CodingHeaderHooks from "../../Hooks/CodingPage/CodingHeaderHooks";
import useS3FileManagement from "../../Hooks/useS3FileManagement";
import useAxiosPrivate from "../../Hooks/useAxiosPrivate";
import useCommonFunctionHooks from "../../Hooks/useCommonFunctionHooks";

const CommentsComponent = ({
  title = "",
  placeholder = "Write message for your trainee",
  isAddAttachment = false,
  className = "",
  hasButton = false,
  comments,
  setComments
}) => {
  const Alert = useContext(AlertContext);
  const [newComment, setNewComment] = useState("");
  const [attachments, setAttachments] = useState([]);
  const fileInputRef = useRef(null);

  const axios = useAxiosPrivate();
  const { getLearnerId } = CodingHeaderHooks();
  const { getCatchBlockDetails, getHeaderDetailsForAxios } = useCommonFunctionHooks();
  const {onMultiPartUpload} = useS3FileManagement();
  

  const handleCommentAttachment = (event) => {
    let commentedDate = String(new Date());
    let newDetails = [...attachments];
    if (newDetails.length >= 1) {
      return;
    }
    let files = Array.from(event.target.files);
    for (let i = 0; i < files.length; i++) {
      let attachment = { id: nanoid(), file: files[i], date: commentedDate };
      newDetails.push(attachment);
    }
    Alert.setCommentAttachment(newDetails);
    setAttachments(newDetails);
    event.target.value = "";
  };

  const handleDeleteCommentAttachment = (attachmentId) => {
    Alert.setCommentAttachment((prevAttachment) =>
      prevAttachment.filter((attachment) => attachment.id !== attachmentId)
    );
    setAttachments((prevAttachment) =>
      prevAttachment.filter((attachment) => attachment.id !== attachmentId)
    );
  };

    const handleAddComments = async (event, button) => {
      if (
        button ||
        button === "score" ||
        (event.ctrlKey && event.key === "Enter")
      ) {
        if (
          newComment !== "" &&
          newComment !== undefined &&
          newComment !== null
        ) {
          try {
            Alert.setIsLoaded(true);
  
            let picType = [];
            let form = new FormData();
  
            form.append("comments", newComment);
            form.append("contentType", picType);
            form.append("lpid", Alert.showBreadCrumbsData.lpId);
            form.append("libtype", Alert.showBreadCrumbsData.type);
            form.append("creatorid", getDataFromStorage("learnerid"));
            form.append("learnerid", Alert.showBreadCrumbsData.learnerId);
  
            if (
              Alert.showBreadCrumbsData.type === constants.libTypeIds.ASSIGNMENT
            ) {
              form.append("questionid", Alert.showBreadCrumbsData.testId);
            } else if (
              Alert.showBreadCrumbsData.type === constants.libTypeIds.MCQ ||
              Alert.showBreadCrumbsData.type === constants.libTypeIds.SQL ||
              Alert.showBreadCrumbsData.type === constants.libTypeIds.DESCRIPTIVE ||
              Alert.showBreadCrumbsData.type === constants.libTypeIds.CODING_SNIPPET
            ) {
              form.append("testid", Alert.showBreadCrumbsData.testId);
            } else {
              form.append("testid", Alert.showBreadCrumbsData.testId);
              form.append("questionid", Alert.showBreadCrumbsData.questionId);
            }
  
            if (Alert.commentAttachment.length > 0) {
              for (let i = 0; i < Alert.commentAttachment.length; i++) {
                form.append(
                  Alert.commentAttachment[i].file.name,
                  Alert.commentAttachment[i].file
                );
                picType.push(
                  Alert.commentAttachment[i].file.name.replace(/^.*\./, "")
                );
              }
            }
  
            let getLinkCount = 0;
            let key = [];
  
            for (let i = 0; i < Alert.commentAttachment.length; i++) {
              key.push(
                `library/submission/${getLearnerId()}/${
                  Alert.commentAttachment[i].file.name
                }`
              );
              const response = await onMultiPartUpload(
                key[i],
                Alert.commentAttachment[i].file
              );
              Alert.commentAttachment[i].key = key[i];
            }
            form.append("attachmentkeys", JSON.stringify(key));  
            let response = await axios({
              data: form,
              method: "post",
              url: "node/admin/test/comment",
              headers: getHeaderDetailsForAxios("multipart").headers,
            });  
            if (response.data.resultCode === constants.RESULT_STATUS.SUCCESS) {
              Alert.setShowComments(false);
  
              if (button === "score") {
                Alert.setIsComment(true);
                Alert.setComment(Alert.comment);
                Alert.setShowNotify({
                  show: true,
                  title: "Info",
                  msg: "Score added successfully",
                });
              } else {
                Alert.setComment("");
  
                if (button === "reject") {
                  return true;
                } else {
                  Alert.setShowNotify({
                    show: true,
                    title: "Info",
                    msg: "Comment added successfully",
                  });
                }
              }
  
  
              if (getLinkCount === Alert.commentAttachment.length) {
                Alert.commentsData.push({
                  comments: Alert.comment,
                  date: String(new Date()),
                  id: response.data.data.insertId,
                  createdby: getDataFromStorage("name"),
                  commentAttachment: Alert.commentAttachment,
                  creatorid: getDataFromStorage("learnerid"),
                  // key:""
                });
  
                Alert.setCommentAttachment([]);
              }
            }
          } catch (error) {
            getCatchBlockDetails(error);
          } finally {
            Alert.setIsLoaded(false);
          }
        } else {
          Alert.setShowNotify({
            show: true,
            title: "Warning",
            msg: "Please enter the comments",
          });
        }
      }
    };

  return (
    <>
      {Alert.isAdmin && (
        <div className="test-view-comments-section-admin-comment-input">
          <div className="test-view-comments-section-admin-comment-title">
            {title}
          </div>
          <div
            onKeyDown={handleAddComments}
            className="test-view-comments-inputwrapper"
          >
            <TextareaAutosize
              minRows={7}
              id={"inputs" + 1}
              key={"inputs" + 1}
              input={newComment}
              value={newComment}
              onChange={(e) => setNewComment(e.target.value)}
              className="test-comments-component-textarea"
              placeholder={placeholder}
            />

            {/* {isAddAttachment && ( */}
              <>
                <div
                  className={
                    Alert.showBreadCrumbsData.type ===
                    constants.libTypeIds.ASSIGNMENT
                      ? "test-comments-utils-area"
                      : "test-comments-utils-area2"
                  }
                >
                  {Alert.showBreadCrumbsData.type ===
                    constants.libTypeIds.ASSIGNMENT && (
                    <div>
                      <svg
                        width="24"
                        height="24"
                        fill="none"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                        className="comments-utits-attachfileicon"
                        onClick={() => fileInputRef.current.click()}
                      >
                        <g clip-path="url(#clip0_1107_17129)">
                          <path
                            fill="#373739"
                            d="M9.29085 21.0002C8.46467 20.9962 7.64753 20.8279 6.887 20.5052C6.12646 20.1824 5.43771 19.7116 4.86085 19.1202C4.28832 18.5775 3.8284 17.9273 3.50743 17.2067C3.18646 16.4861 3.01073 15.7093 2.99029 14.9208C2.96986 14.1322 3.10512 13.3474 3.38835 12.6111C3.67157 11.8749 4.09719 11.2017 4.64085 10.6302L12.0009 3.20016C12.3939 2.80783 12.8624 2.49923 13.378 2.29298C13.8936 2.08674 14.4457 1.98712 15.0009 2.00016C15.5956 2.00218 16.1839 2.12259 16.7316 2.35437C17.2793 2.58615 17.7754 2.92466 18.1909 3.35016C19.0178 4.14639 19.4974 5.23667 19.5255 6.38433C19.5536 7.53199 19.1279 8.64442 18.3409 9.48015L10.9409 16.9102C10.7038 17.1488 10.4218 17.3379 10.1111 17.4667C9.80036 17.5954 9.46718 17.6612 9.13085 17.6602C8.76753 17.6606 8.40779 17.5883 8.07287 17.4475C7.73795 17.3067 7.43464 17.1001 7.18085 16.8402C6.67358 16.349 6.38062 15.6775 6.36564 14.9716C6.35066 14.2657 6.61487 13.5824 7.10085 13.0702L13.9309 6.21016C14.1252 6.08106 14.3586 6.024 14.5907 6.04887C14.8227 6.07374 15.0387 6.17896 15.2013 6.34632C15.3639 6.51367 15.4629 6.73263 15.4811 6.96526C15.4992 7.1979 15.4355 7.42957 15.3009 7.62016L8.47085 14.4802C8.35696 14.6174 8.30152 14.7938 8.31649 14.9715C8.33145 15.1492 8.41562 15.3139 8.55085 15.4302C8.69156 15.5718 8.88126 15.6542 9.08085 15.6602C9.15479 15.6612 9.2282 15.6476 9.29685 15.6202C9.36551 15.5927 9.42804 15.5519 9.48085 15.5002L16.8709 8.07016C17.2857 7.60934 17.5025 7.00379 17.4744 6.38441C17.4463 5.76502 17.1756 5.18157 16.7208 4.76016C16.2984 4.3216 15.724 4.06162 15.1157 4.03371C14.5075 4.00581 13.9116 4.21211 13.4509 4.61016L6.06085 12.0002C5.7015 12.3861 5.42201 12.8394 5.23848 13.3337C5.05494 13.8281 4.97099 14.354 4.99143 14.8809C5.01188 15.4079 5.13633 15.9256 5.35762 16.4043C5.57891 16.883 5.89267 17.3132 6.28085 17.6702C6.67013 18.0737 7.13592 18.3956 7.65101 18.6171C8.16611 18.8386 8.72018 18.9552 9.28085 18.9602C9.76427 18.9641 10.2437 18.8725 10.6916 18.6905C11.1395 18.5086 11.5471 18.24 11.8909 17.9002L19.2809 10.4702C19.3734 10.3769 19.4835 10.3028 19.6047 10.2521C19.7259 10.2014 19.8559 10.1751 19.9873 10.1746C20.1187 10.1741 20.2489 10.1996 20.3705 10.2494C20.4921 10.2993 20.6026 10.3726 20.6959 10.4652C20.7891 10.5577 20.8632 10.6678 20.9139 10.789C20.9646 10.9102 20.9909 11.0402 20.9914 11.1716C20.9919 11.303 20.9665 11.4332 20.9166 11.5548C20.8667 11.6764 20.7934 11.7869 20.7009 11.8802L13.3109 19.3102C12.7862 19.8441 12.1606 20.2685 11.4705 20.5586C10.7804 20.8487 10.0395 20.9988 9.29085 21.0002Z"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_1107_17129">
                            <rect width="24" height="24" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                      <input
                        multiple
                        ref={fileInputRef}
                        type="file"
                        accept="image/*"
                        onChange={handleCommentAttachment}
                        className="comments-utits-attachfileinput"
                      />
                    </div>
                  )}

                  <div
                    className={`comments-utils-key-to-submit ${
                      Alert.showBreadCrumbsData.type ===
                      constants.libTypeIds.ASSIGNMENT
                        ? ""
                        : "comments-utils-key-to-submit2"
                    }`}
                  >
                    Ctrl+Enter to Submit
                  </div>
                </div>

                <div className="test-comments-file-container-div">
                  {/* files */}
                  {Alert.showBreadCrumbsData.type ===
                    constants.libTypeIds.ASSIGNMENT &&
                    attachments.map((attachment) => (
                      <div
                        key={attachment.id}
                        className="test-comments-file-container"
                      >
                        <div className="comments-file-sec">
                          <svg
                            width="24"
                            height="24"
                            fill="none"
                            viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg"
                            className="comments-file-image-icon"
                          >
                            <path
                              fill="#D8D8FF"
                              d="M13.5 9C13.1022 9 12.7206 8.84196 12.4393 8.56066C12.158 8.27936 12 7.89782 12 7.5C12 7.10218 12.158 6.72064 12.4393 6.43934C12.7206 6.15804 13.1022 6 13.5 6C13.8978 6 14.2794 6.15804 14.5607 6.43934C14.842 6.72064 15 7.10218 15 7.5C15 7.89782 14.842 8.27936 14.5607 8.56066C14.2794 8.84196 13.8978 9 13.5 9Z"
                            />
                            <path
                              fill="#B2B1FF"
                              d="M19 2H5C4.20508 2.00237 3.4434 2.31921 2.8813 2.8813C2.31921 3.4434 2.00237 4.20508 2 5V13.86L5.88 9.98C6.4517 9.43586 7.21074 9.13238 8 9.13238C8.78926 9.13238 9.5483 9.43586 10.12 9.98L12.991 12.867L13.879 11.979C14.4426 11.4185 15.2052 11.1039 16 11.1039C16.7948 11.1039 17.5574 11.4185 18.121 11.979L22 15.86V5C21.9976 4.20508 21.6808 3.4434 21.1187 2.8813C20.5566 2.31921 19.7949 2.00237 19 2ZM13.5 9C13.1022 9 12.7206 8.84196 12.4393 8.56066C12.158 8.27936 12 7.89782 12 7.5C12 7.10218 12.158 6.72064 12.4393 6.43934C12.7206 6.15804 13.1022 6 13.5 6C13.8978 6 14.2794 6.15804 14.5607 6.43934C14.842 6.72064 15 7.10218 15 7.5C15 7.89782 14.842 8.27936 14.5607 8.56066C14.2794 8.84196 13.8978 9 13.5 9Z"
                            />
                            <path
                              fill="#6563FF"
                              d="M10.12 9.97994C9.5483 9.4358 8.78926 9.13232 8 9.13232C7.21074 9.13232 6.4517 9.4358 5.88 9.97994L2 13.8599V18.9999C2.00237 19.7949 2.31921 20.5565 2.8813 21.1186C3.4434 21.6807 4.20508 21.9976 5 21.9999H19C19.815 21.9999 20.595 21.6669 21.16 21.0799L10.12 9.97994Z"
                            />
                            <path
                              fill="#D8D8FF"
                              d="M22.0012 15.8581L18.1222 11.9791C17.5586 11.4186 16.796 11.104 16.0012 11.104C15.2063 11.104 14.4438 11.4186 13.8802 11.9791L12.9922 12.8671L21.1572 21.0761C21.6992 20.5211 22.0022 19.7761 22.0012 19.0001V15.8581Z"
                            />
                          </svg>
                          <Typography id="comments-file-image-name">
                            {attachment.file.name}
                          </Typography>
                          <Typography
                            variant="caption"
                            id="comments-file-image-size"
                          >
                            {attachment.hasOwnProperty("file") &&
                            attachment.file.size !== undefined
                              ? (attachment.file.size / 1e6).toFixed(2) > 1
                                ? `${(attachment.file.size / 1e6).toFixed(
                                    2
                                  )} MB`
                                : `${(attachment.file.size / 1024).toFixed(
                                    2
                                  )} KB`
                              : ""}
                          </Typography>
                        </div>
                        <svg
                          width="24"
                          height="24"
                          fill="none"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                          id="comments-file-image-xmark-icon"
                          onClick={() =>
                            handleDeleteCommentAttachment(attachment.id)
                          }
                        >
                          <path
                            fill="#373739"
                            d="M13.0567 11.9994L17.7783 7.28477C17.9194 7.14363 17.9987 6.95221 17.9987 6.7526C17.9987 6.553 17.9194 6.36157 17.7783 6.22043C17.6372 6.07929 17.4458 6 17.2462 6C17.0466 6 16.8552 6.07929 16.7141 6.22043L12 10.9425L7.28592 6.22043C7.14479 6.07929 6.95338 6 6.7538 6C6.55422 6 6.36281 6.07929 6.22169 6.22043C6.08056 6.36157 6.00128 6.553 6.00128 6.7526C6.00128 6.95221 6.08056 7.14363 6.22169 7.28477L10.9433 11.9994L6.22169 16.7139C6.15144 16.7836 6.09569 16.8665 6.05764 16.9579C6.01959 17.0492 6 17.1472 6 17.2461C6 17.3451 6.01959 17.443 6.05764 17.5344C6.09569 17.6257 6.15144 17.7086 6.22169 17.7783C6.29136 17.8485 6.37425 17.9043 6.46558 17.9424C6.55691 17.9804 6.65487 18 6.7538 18C6.85274 18 6.9507 17.9804 7.04203 17.9424C7.13335 17.9043 7.21625 17.8485 7.28592 17.7783L12 13.0562L16.7141 17.7783C16.7838 17.8485 16.8666 17.9043 16.958 17.9424C17.0493 17.9804 17.1473 18 17.2462 18C17.3451 18 17.4431 17.9804 17.5344 17.9424C17.6257 17.9043 17.7086 17.8485 17.7783 17.7783C17.8486 17.7086 17.9043 17.6257 17.9424 17.5344C17.9804 17.443 18 17.3451 18 17.2461C18 17.1472 17.9804 17.0492 17.9424 16.9579C17.9043 16.8665 17.8486 16.7836 17.7783 16.7139L13.0567 11.9994Z"
                          />
                        </svg>
                      </div>
                    ))}
                </div>
              </>
            {/* )} */}
          </div>

          {hasButton && (
            <div className="commentsFooter">
              <Button
                disable={Alert.isLoaded}
                size={"sm"}
                onClick={(e) => {
                  handleAddComments(e, true);
                }}
                hierarchy={{
                  type: "primary",
                  buttonText: "Add comment",
                }}
              />
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default CommentsComponent;
